export const env = "mliProd";

// qualTechDev
// mliDev
// mliUat
// mliProd
